import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LogService } from 'src/app/core/services/log/log.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { DureeExecutionByType, ModuleType, ModuleTypeWithoutSP, NatureAbandon, NatureAbandonString, PeriodeExecutionByType, Prestation, PrestationStatut, PrestationStatutString, PrestationType, PrestationTypeString, PrestationTypeWithoutSpString, QualificationEtat, QualificationEtatString, StatutBeneficiaire, StatutBeneficiaireString } from 'src/app/shared/models/prestation';
import { Unavailability } from 'src/app/shared/models/unavailability';
import {
	FormControl,
	FormGroup,
} from '@angular/forms';
import { Address } from 'src/app/shared/models/address';
import { PARAM_LABEL_INTERVENANT } from 'src/app/core/services/constant/constants.service';
import { User } from 'src/app/shared/models/security/user';
import { Employee } from 'src/app/shared/models/employee/employee';
import { Beneficiaire } from 'src/app/shared/models/beneficiaire';
import { Situation } from 'src/app/shared/models/situation';
import { OrigineDemande } from 'src/app/shared/models/origineDemande';
import { Prescripteur } from 'src/app/shared/models/prescripteur';
import { ObjectifPro } from 'src/app/shared/models/objectifPro';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Editor, toHTML } from 'ngx-editor';
import { TypeFormation } from 'src/app/shared/models/typeFormation';
import { EligibiliteBeneficiaire } from 'src/app/shared/models/eligibiliteBeneficiaire';
import { NiveauEtude } from 'src/app/shared/models/niveauEtude';
import { NiveauQualification } from 'src/app/shared/models/niveauQualification';
import { StatutProfessionnel } from 'src/app/shared/models/statutProfessionnel';
import { TauxReconnaissance } from 'src/app/shared/models/tauxReconnaissance';
import { BonCommande } from 'src/app/shared/models/bonCommande';
import { DateUtils } from 'src/app/shared/utils/date-utils';
import { PrescripteurContact } from 'src/app/shared/models/prescripteurContact';
import { Service } from 'src/app/shared/models/service';
import { debounceTime, distinctUntilChanged, filter, switchMap } from 'rxjs';

@Component({
	selector: 'app-prestation-form',
	templateUrl: './prestation-form.component.html',
	styleUrls: ['./prestation-form.component.scss']
})
export class PrestationFormComponent implements OnInit {
	@Input() prestation: Prestation;
	@Input() isAddForm: boolean;
	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	@Input() isValidateButtonClicked: { value: boolean };
	@Input() isLoadingBeneficiaires: { value: boolean };
	@Input() form: FormGroup;
	@Output() sendForm: EventEmitter<any> = new EventEmitter();
	@Output() hideModal: EventEmitter<any> = new EventEmitter();

	isQDSelected = false;
	isASSelected = false;
	isACSelected = false;
	isCAMEOSelected = false;
	isEAPSelected = false;
	isSPSelected = false;

	showStatutOUVERT = true;
	showStatutENCOURS = true;
	showStatutANNULE = true;
	showStatutCLOT = true;

	isStatutDESelected = false;
	isStatutEESelected = false;
	isStatutEFSelected = false;

	showErrorModuleAlreadyCreated = false;
	showErrorDatesNotBetweenBdc = false;
	showChefFileBoolInput = false;
	showChefFileServiceListInput = false;
	showFieldModuleEmployee = false;
	showFieldDateDebutContrat = false;
	showFieldDateFinContrat = false;
	showFieldNatureAbandon = false;
	showFieldCommentaireAbandon = false;
	showFieldChoixIntervenantSP = false;
	isSelectedStatutANNULE = false;
	isSelectedStatutCLOT = false;

	showModal = false;

	MAX_NAME_CHAR = 25;
	NAME_PATTERN = new RegExp("^[a-zA-z'éèàç.-_]+( [a-zA-z'éèàç.-_]+)*$");

	prestations: Prestation[] = null;

	labelIntervenantCapitalized: string;

	listIntervenant: Employee[];
	listSelectedIntervenant: Employee[];

	listModuleEnum = ModuleTypeWithoutSP;
	listAllModule = Object.keys(this.listModuleEnum);
	listSelectedModule: string[] = [];
	listModules: Prestation[];
	listModuleToCreate: string[] = [];

	isPreferencesActive = false;

	user: User;

	emailActive = false;
	nomStructureActive = false;
	addressStructureActive = false;
	typeStructureActive = false;
	emailStructureActive = false;
	phoneStructureActive = false;
	listBeneficiaire: Beneficiaire[];
	listBeneficiaireInput: Beneficiaire[];
	listSituation: Situation[];
	listOrigineDemande: OrigineDemande[];
	listPrescripteur: Prescripteur[];
	listPrescripteurContact: PrescripteurContact[];
	listObjectifPro: ObjectifPro[];
	listTypeFormation: TypeFormation[];
	listTauxReconnaissance: TauxReconnaissance[];
	listNiveauEtude: NiveauEtude[];
	listNiveauQualification: NiveauQualification[];
	listEligibiliteBeneficiaire: EligibiliteBeneficiaire[];
	listStatutProfessionnel: StatutProfessionnel[];
	listQualification: Prestation[];
	listBonCommande: BonCommande[];
	listServiceChefFile: Service[] = [];


	selectedAddress = new Address();
	selectedExpertises;
	selectedTypePrestation: string;

	chooseIntervenantModalref: BsModalRef;

	public PrestationTypeStringEnum = PrestationTypeString;
	public PrestationTypeWithoutSpStringEnum = PrestationTypeWithoutSpString;
	public PrestationTypeEnum = PrestationType;

	public QualificationEtatStringEnum = QualificationEtatString;
	public QualificationEtatEnum = QualificationEtat;

	public PrestationStatutStringEnum = PrestationStatutString;
	public PrestationStatutEnum = PrestationStatut;

	public StatutBeneficiaireStringEnum = StatutBeneficiaireString;
	public StatutBeneficiaireEnum = StatutBeneficiaire;

	public NatureAbandonStringEnum = NatureAbandonString;
	public NatureAbandonEnum = NatureAbandon;

	isAssistant: boolean;
	isIntervenant: boolean;
	editorRaison: Editor;
	editorImperatifs: Editor;
	editorRaisonDemandeAccomp: Editor;
	editorDifficultes: Editor;
	editorBesoins: Editor;
	editorCompetenceProPerso: Editor;
	editorMetiersCibles: Editor;
	editorOrigineHandicap: Editor;
	editorRapportHandicap: Editor;
	editorDoleances: Editor;
	editorLogement: Editor;
	editorSante: Editor;
	editorSituationFinanciere: Editor;
	editorSituationFamiliale: Editor;
	editorSmBilan: Editor;
	editorSmAccomp: Editor;
	editorDeProjetPro: Editor;
	editorDeRuptureParcours: Editor;
	editorDeBesoinsIdent: Editor;
	editorEeLimites: Editor;
	editorEeQuestEmploi: Editor;
	editorEeBesoinsAdapt: Editor;
	editorEePbAccess: Editor;
	editorEeAccompDejaMene: Editor;
	editorEeSyntheseSitEmployeur: Editor;
	editorEeHoraires: Editor;
	editorEeFichePoste: Editor;
	editorEfLimiteCapacite: Editor;
	editorEfQuestionnement: Editor;
	editorEfAccompDejaMene: Editor;
	editorEfAccessibilite: Editor;
	editorEfBesoinsAt: Editor;
	editorEfPlanning: Editor;
	editorEfRemarqueRef: Editor;
	editorSyntheseInfo: Editor;
	editorPremieresOrientations: Editor;
	editorLangage: Editor;
	editorPraxie: Editor;
	editorMemoire: Editor;
	editorFonctExecutif: Editor;
	editorFonctAttent: Editor;
	editorCognitionSociale: Editor;
	editorComportement: Editor;
	editorPreconisations: Editor;
	editorObservations: Editor;
	// editorOrientationMdph: Editor;
	// editorFreins: Editor;
	// editorRessources: Editor;
	// editorContraintes: Editor;
	// editorPropositionsActions: Editor;
	// editorPlanActionPerso: Editor;
	editorAnalyseAdequation: Editor;
	editorRecommandantions: Editor;

	editorPreconisationsProposes: Editor;
	editorDescription: Editor;
	editorComplements: Editor;
	editorDescriptionS3: Editor;
	editorFreinS3: Editor;
	editorReponseS3: Editor;
	editorDescriptionS6: Editor;
	editorFreinS6: Editor;
	editorReponseS6: Editor;

	editorRessourcesFinancieres: Editor;
	editorSatisfaction: Editor;
	editorStress: Editor;
	editorForces: Editor;
	editorAttention: Editor;
	editorGnosies: Editor;
	editorPointVigilence: Editor;
	editorPpDescriptionPosteBenef: Editor;
	editorPpDescriptionPosteOf: Editor;
	editorCommentaireAbandon: Editor;

	beneficiaireInput = new FormControl();

	constructor(
		private logger: LogService,
		private facade: FacadeService,
		public bsModalRef: BsModalRef,
		private dateUtils: DateUtils
	) { }

	ngOnInit(): void {
		this.editorRaison = new Editor();
		this.editorImperatifs = new Editor();
		this.editorRaisonDemandeAccomp = new Editor();
		this.editorCompetenceProPerso = new Editor();
		this.editorMetiersCibles = new Editor();
		this.editorDifficultes = new Editor();
		this.editorBesoins = new Editor();
		this.editorOrigineHandicap = new Editor();
		this.editorRapportHandicap = new Editor();
		this.editorDoleances = new Editor();
		this.editorLogement = new Editor();
		this.editorSante = new Editor();
		this.editorSituationFamiliale = new Editor();
		this.editorSituationFinanciere = new Editor();
		this.editorSmBilan = new Editor();
		this.editorSmAccomp = new Editor();
		this.editorDeProjetPro = new Editor();
		this.editorDeRuptureParcours = new Editor();
		this.editorDeBesoinsIdent = new Editor();
		this.editorEeLimites = new Editor();
		this.editorEeQuestEmploi = new Editor();
		this.editorEeBesoinsAdapt = new Editor();
		this.editorEePbAccess = new Editor();
		this.editorEeAccompDejaMene = new Editor();
		this.editorEeSyntheseSitEmployeur = new Editor();
		this.editorEeHoraires = new Editor();
		this.editorEeFichePoste = new Editor();
		this.editorEfLimiteCapacite = new Editor();
		this.editorEfQuestionnement = new Editor();
		this.editorEfAccompDejaMene = new Editor();
		this.editorEfAccessibilite = new Editor();
		this.editorEfBesoinsAt = new Editor();
		this.editorEfPlanning = new Editor();
		this.editorEfRemarqueRef = new Editor();
		this.editorSyntheseInfo = new Editor();
		this.editorPremieresOrientations = new Editor();
		this.editorLangage = new Editor();
		this.editorPraxie = new Editor();
		this.editorMemoire = new Editor();
		this.editorFonctExecutif = new Editor();
		this.editorFonctAttent = new Editor();
		this.editorCognitionSociale = new Editor();
		this.editorComportement = new Editor();
		this.editorPreconisations = new Editor();
		this.editorObservations = new Editor();
		// this.editorOrientationMdph = new Editor();
		// this.editorFreins = new Editor();
		// this.editorRessources = new Editor();
		// this.editorContraintes = new Editor();
		// this.editorPropositionsActions = new Editor();
		// this.editorPlanActionPerso = new Editor();
		this.editorAnalyseAdequation = new Editor();
		this.editorRecommandantions = new Editor();

		this.editorPreconisationsProposes = new Editor();
		this.editorDescription = new Editor();
		this.editorComplements = new Editor();
		this.editorDescriptionS3 = new Editor();
		this.editorFreinS3 = new Editor();
		this.editorReponseS3 = new Editor();
		this.editorDescriptionS6 = new Editor();
		this.editorFreinS6 = new Editor();
		this.editorReponseS6 = new Editor();

		this.editorRessourcesFinancieres = new Editor();
		this.editorSatisfaction = new Editor();
		this.editorStress = new Editor();
		this.editorForces = new Editor();
		this.editorAttention = new Editor();
		this.editorGnosies = new Editor();
		this.editorPointVigilence = new Editor();
		this.editorPpDescriptionPosteBenef = new Editor();
		this.editorPpDescriptionPosteOf = new Editor();
		this.editorCommentaireAbandon = new Editor();

		if (this.prestation) {
			this.labelIntervenantCapitalized =
				this.facade.dataStorageService.getLabelCapitalized(
					PARAM_LABEL_INTERVENANT
				);

			this.isAssistant = this.facade.dataStorageService.isAssistant();
			this.isIntervenant = this.facade.dataStorageService.isIntervenant();
			// this.facade.intervenantService.getAllIntervenants().subscribe({
			// 	next: (val) => {
			// 		this.listIntervenant = val;
			// 	},
			// 	error: (err) => {
			// 		this.logger.error(err);
			// 	}
			// });
			switch (this.prestation.statut) {
				case this.PrestationStatutEnum.OUVERT: {
					this.showStatutOUVERT = true;
					this.showStatutENCOURS = true;
					this.showStatutANNULE = true;
					this.showStatutCLOT = false;
					break;
				}
				case this.PrestationStatutEnum.COURS: {
					this.showStatutOUVERT = false;
					this.showStatutENCOURS = true;
					this.showStatutANNULE = true;
					this.showStatutCLOT = true;
					break;
				}
				case this.PrestationStatutEnum.CLOT: {
					this.showStatutOUVERT = false;
					this.showStatutENCOURS = true;
					this.showStatutANNULE = true;
					this.showStatutCLOT = true;
					break;
				}
				case this.PrestationStatutEnum.ANNULE: {
					this.showStatutOUVERT = true;
					this.showStatutENCOURS = true;
					this.showStatutANNULE = true;
					this.showStatutCLOT = true;
					break;
				}
			}

			this.user = this.facade.dataStorageService.getUser();

			this.isPreferencesActive =
				this.facade.dataStorageService.isPreferencesBeneficiaireActive();

			this.facade.situationService.getAllSituation().subscribe({
				next: (val) => {
					this.listSituation = val;
				},
				error: (err) => {
					this.logger.error(err);
				}
			});
			if (this.isIntervenant) {
				this.facade.prescripteurService.getAllPrescripteurs().subscribe({
					next: (val) => {
						this.listPrescripteur = val;
					},
					error: (err) => {
						this.logger.error(err);
					}
				});
			} else {
				this.facade.prescripteurService.getPrescripteurByRegion(this.facade.dataStorageService.getRegion()?.id).subscribe({
					next: (val) => {
						this.listPrescripteur = val;
					},
					error: (err) => {
						this.logger.error(err);
					}
				});
			}
			// this.facade.origineDemandeService.getAllOrigineDemande().subscribe({
			// 	next: (val) => {
			// 		this.listOrigineDemande = val;
			// 	},
			// 	error: (err) => {
			// 		this.logger.error(err);
			// 	}
			// });
			this.facade.objectifProService.getAllObjectifPro().subscribe({
				next: (val) => {
					this.listObjectifPro = val;
				},
				error: (err) => {
					this.logger.error(err);
				}
			});
			this.facade.typeFormationService.getAllTypeFormation().subscribe({
				next: (val) => {
					this.listTypeFormation = val;
				},
				error: (err) => {
					this.logger.error(err);
				}
			});
			this.facade.tauxReconnaissanceService.getAllTauxReconnaissance().subscribe({
				next: (val) => {
					this.listTauxReconnaissance = val;
				},
				error: (err) => {
					this.logger.error(err);
				}
			});
			this.facade.niveauEtudeService.getAllNiveauEtude().subscribe({
				next: (val) => {
					this.listNiveauEtude = val;
				},
				error: (err) => {
					this.logger.error(err);
				}
			});
			this.facade.niveauQualificationService.getAllNiveauQualification().subscribe({
				next: (val) => {
					this.listNiveauQualification = val;
				},
				error: (err) => {
					this.logger.error(err);
				}
			});
			this.facade.statutProfessionnelService.getAllStatutProfessionnel().subscribe({
				next: (val) => {
					this.listStatutProfessionnel = val;
				},
				error: (err) => {
					this.logger.error(err);
				}
			});
			this.facade.eligibiliteBeneficiaireService.getAllEligibiliteBeneficiaire().subscribe({
				next: (val) => {
					this.listEligibiliteBeneficiaire = val;
				},
				error: (err) => {
					this.logger.error(err);
				}
			});
			if (this.isIntervenant) {
				this.facade.qualificationService.getQualificationById(this.prestation.idQualification).subscribe({
					next: (val) => {
						this.listQualification = [];
						this.listQualification.push(val);
					},
					error: (err) => {
						this.logger.error(err);
					}
				});
			} else {
				this.facade.qualificationService.getQualificationByService(this.facade.dataStorageService.getService()?.id).subscribe({
					next: (val) => {
						this.listQualification = val;
					},
					error: (err) => {
						this.logger.error(err);
					}
				});
			}
			// if(!this.isIntervenant){
			// 	this.facade.bonCommandeService.getBonCommandeByServiceAndRegion(this.facade.dataStorageService.getService()?.id,
			// 		this.facade.dataStorageService.getRegion()?.id).subscribe({
			// 		next: (val) => {
			// 			this.listBonCommande = val;
			// 		},
			// 		error: (err) => {
			// 			this.logger.error(err);
			// 		}
			// 	});
			// }
			this.facade.employeeService.getAllActiveEmployees().subscribe({
				next: (val) => {
					this.listIntervenant = val;
				},
				error: (err) => {
					this.logger.error(err);
				}
			});

			if (!this.isAddForm) {
				this.form.patchValue({
					typePrestation: this.prestation.typePrestation,
					statut: this.prestation.statut,
					natureAbandon: this.prestation.natureAbandon,
					commentaireAbandon: this.prestation.commentaireAbandon,
					etatQualification: this.prestation.etatQualification,
					dateDepot:
						this.prestation.dateDepot !== null && this.prestation.dateDepot !== ''
							? new Date(this.prestation.dateDepot)
							: null,
					dateDebut:
						this.prestation.dateDebut !== null && this.prestation.dateDebut !== ''
							? new Date(this.prestation.dateDebut)
							: null,
					dateFin:
						this.prestation.dateFin !== null && this.prestation.dateFin !== ''
							? new Date(this.prestation.dateFin)
							: null,
					dateLimite:
						this.prestation.dateLimite !== null && this.prestation.dateLimite !== ''
							? new Date(this.prestation.dateLimite)
							: null,
					dateValidation:
						this.prestation.dateValidation !== null && this.prestation.dateValidation !== ''
							? new Date(this.prestation.dateValidation)
							: null,
					periode: this.prestation.periode,
					duree: this.prestation.duree,
					dureePrevisionnelle: this.prestation.dureePrevisionnelle,
					beneficiaire: this.prestation.beneficiaire?.id,
					bonCommande: this.prestation.bonCommande?.id,
					situation: this.prestation.situation?.id,
					raison: this.prestation.raison,
					imperatifs: this.prestation.imperatifs,
					//origineDemande: this.prestation.origineDemande?.id,
					prescripteur: this.prestation.prescripteur?.id,
					intervenant: this.prestation.intervenant?.id,
					raisonDemandeAccomp: this.prestation.raisonDemandeAccomp,
					objectifPro: this.prestation.objectifPro?.id,
					typeAccompagnement: this.prestation.typeAccompagnement,
					difficultes: this.prestation.difficultes,
					besoins: this.prestation.besoins,
					origineHandicap: this.prestation.origineHandicap,
					rapportHandicap: this.prestation.rapportHandicap,
					doleances: this.prestation.beneficiaire?.doleances,
					niveauEtude: this.prestation.beneficiaire?.niveauEtude?.id,
					statutProfessionnel: this.prestation.beneficiaire?.statutProfessionnel?.id,
					tauxReconnaissance: this.prestation.beneficiaire?.tauxReconnaissance?.id,
					logement: this.prestation.logement,
					sante: this.prestation.sante,
					situationFinanciere: this.prestation.situationFinanciere,
					situationFamiliale: this.prestation.situationFamiliale,
					smBilan: this.prestation.smBilan,
					smAccomp: this.prestation.smAccomp,
					deMetiersCibles: this.prestation.deMetiersCibles,
					deProjetPro: this.prestation.deProjetPro,
					deRuptureParcours: this.prestation.deRuptureParcours,
					deBesoinsIdent: this.prestation.deBesoinsIdent,
					eeLimites: this.prestation.eeLimites,
					eeQuestEmploi: this.prestation.eeQuestEmploi,
					eeBesoinsAdapt: this.prestation.eeBesoinsAdapt,
					eePbAccess: this.prestation.eePbAccess,
					eeAccompDejaMene: this.prestation.eeAccompDejaMene,
					eeNomEntreprise: this.prestation.eeNomEntreprise,
					eeNomContactEntreprise: this.prestation.eeNomContactEntreprise,
					eePrenomContactEntreprise: this.prestation.eePrenomContactEntreprise,
					eeMailContactEntreprise: this.prestation.eeMailContactEntreprise,
					eeTelContactEntreprise: this.prestation.eeTelContactEntreprise,
					eeSyntheseSitEmployeur: this.prestation.eeSyntheseSitEmployeur,
					eeHoraires: this.prestation.eeHoraires,
					eeFichePoste: this.prestation.eeFichePoste,
					efLimiteCapacite: this.prestation.efLimiteCapacite,
					efQuestionnement: this.prestation.efQuestionnement,
					efAccompDejaMene: this.prestation.efAccompDejaMene,
					efAccessibilite: this.prestation.efAccessibilite,
					efTypeFormation: this.prestation.efTypeFormation,
					efBesoinsAt: this.prestation.efBesoinsAt,
					efNomCentreFormation: this.prestation.efNomCentreFormation,
					efPlanning: this.prestation.efPlanning,
					efRemarqueRef: this.prestation.efRemarqueRef,
					metiersCibles: this.prestation.metiersCibles,
					syntheseInfo: this.prestation.syntheseInfo,
					premieresOrientations: this.prestation.premieresOrientations,
					langage: this.prestation.langage,
					praxie: this.prestation.praxie,
					memoire: this.prestation.memoire,
					fonctExecutif: this.prestation.fonctExecutif,
					fonctAttent: this.prestation.fonctAttent,
					cognitionSociale: this.prestation.cognitionSociale,
					comportement: this.prestation.comportement,
					preconisations: this.prestation.preconisations,
					observations: this.prestation.observations,
					analyseAdequation: this.prestation.analyseAdequation,
					recommandantions: this.prestation.recommandantions,
					statutBeneficiaire: this.prestation.statutBeneficiaire,
					numeroCommande: this.prestation.numeroCommande,

					// datePrescription: this.prestation.datePrescription,
					// datePremierContact: this.prestation.datePremierContact,
					// datePremierRv: this.prestation.datePremierRv,
					// dateS3: this.prestation.dateS3,
					// dateS6: this.prestation.dateS6,
					// preconisationsProposes: this.prestation.preconisationsProposes,
					// comprehensionPreco: this.prestation.comprehensionPreco,
					// description: this.prestation.description,
					// complements: this.prestation.complements,
					// nomS3: this.prestation.nomS3,
					// prenomS3: this.prestation.prenomS3,
					// fonctionS3: this.prestation.fonctionS3,
					// preconisationMeoS3: this.prestation.preconisationMeoS3,
					// descriptionS3: this.prestation.descriptionS3,
					// freinS3: this.prestation.freinS3,
					// reponseS3: this.prestation.reponseS3,
					// nomS6: this.prestation.nomS6,
					// prenomS6: this.prestation.prenomS6,
					// fonctionS6: this.prestation.fonctionS6,
					// preconisationMeoS6: this.prestation.preconisationMeoS6,
					// descriptionS6: this.prestation.descriptionS6,
					// freinS6: this.prestation.preconisationMeoS6,
					// reponseS6: this.prestation.reponseS6,
					dateContactPrescripteur: this.prestation.dateContactPrescripteur !== null && this.prestation.dateContactPrescripteur !== ''
						? new Date(this.prestation.dateContactPrescripteur)
						: null,
					dateContactPersonne: this.prestation.dateContactPersonne !== null && this.prestation.dateContactPersonne !== ''
						? new Date(this.prestation.dateContactPersonne)
						: null,
					dateContactEmployeur: this.prestation.dateContactEmployeur !== null && this.prestation.dateContactEmployeur !== ''
						? new Date(this.prestation.dateContactEmployeur)
						: null,
					meoSolutions: this.prestation.meoSolutions,
					precoNonMeo: this.prestation.precoNonMeo,
					raisons: this.prestation.raisons,
					propositionAs: this.prestation.propositionAs,
					propositionAutre: this.prestation.propositionAutre,
					propositionAutreDetails: this.prestation.propositionAutreDetails,
					heuresDeclarees: this.prestation.heuresDeclarees,

					ressourcesFinancieres: this.prestation.ressourcesFinancieres,
					niveauRendement: this.prestation.niveauRendement,
					satisfaction: this.prestation.satisfaction,
					stress: this.prestation.stress,
					forces: this.prestation.forces,
					attention: this.prestation.attention,
					gnosies: this.prestation.gnosies,
					pointVigilence: this.prestation.pointVigilence,
					ppIntitulePoste: this.prestation.ppIntitulePoste,
					ppDescriptionPosteBenef: this.prestation.ppDescriptionPosteBenef,
					ppDescriptionPosteOf: this.prestation.ppDescriptionPosteOf,
					ppEntrepriseVise: this.prestation.ppEntrepriseVise,
					idQualification: this.prestation.idQualification,
					serviceChefFile: this.prestation.serviceChefFile?.id,
					showServiceChefFile: this.prestation.serviceChefFile != null ? true : false,

					dateDebutContrat:
						this.prestation.dateDebutContrat !== null && this.prestation.dateDebutContrat !== ''
							? new Date(this.prestation.dateDebutContrat)
							: null,
					dateFinContrat:
						this.prestation.dateFinContrat !== null && this.prestation.dateFinContrat !== ''
							? new Date(this.prestation.dateFinContrat)
							: null,
					salarieEntreprise: this.prestation.salarieEntreprise,
					accordEmployeur: this.prestation.accordEmployeur,
					arretTravail: this.prestation.arretTravail,
					agentFonctPub: this.prestation.agentFonctPub,
					accordHandicap: this.prestation.accordHandicap,
				});

				this.listPrescripteurContact = this.prestation.prescripteur?.contacts;
				this.form.patchValue({
					prescripteurContact: this.prestation.prescripteurContact?.id
				})

				this.isLoadingBeneficiaires.value = false;
				if (this.typePrestation.value == PrestationType.QD && this.prestation.beneficiaire?.typeHandicaps?.length > 1) {
					this.showChefFileBoolInput = true;
					if (this.prestation.serviceChefFile != null) {
						this.showChefFileServiceListInput = true;
					}
					this.facade.serviceService.getAllService().subscribe({
						next: (services) => {
							console.log(services);
							services.forEach(e => {
								if (this.prestation.beneficiaire.typeHandicaps.some(f => f.id === e.typeHandicap.id) && e.id != this.facade.dataStorageService.getService().id) {
									this.listServiceChefFile.push(e);
								}
							})
						}
					})
				}

				this.togglePrestationTypeSelected();
				this.onStatutProChanged();
				this.onStatutChanged();
			}

			this.listBeneficiaire = [];
			this.listBeneficiaireInput = [];
			if (this.isAddForm) {
				if (this.isIntervenant) {
					this.facade.beneficiaireService.getByIntervenant(this.facade.dataStorageService.getUser()?.id).subscribe({
						next: (beneficiaires) => {
							this.listBeneficiaire = beneficiaires;
							this.isLoadingBeneficiaires.value = false;
						},
						error: (err) => {
							this.logger.error(err);
						}
					});
				}else{
					this.beneficiaireInput.valueChanges
				.pipe(
					debounceTime(300),
					distinctUntilChanged(),
					filter((val: string) => val && val.length > 2), // commence la recherche à partir de 3 caractères
					switchMap(searchText => {
						const serviceId = this.facade.dataStorageService.getService()?.id;
						const regionId = this.facade.dataStorageService.getRegion()?.id;

						return this.facade.beneficiaireService.getByServiceAndRegionPagination(
							serviceId,
							regionId,
							0,
							20,
							searchText || "NotDefined"
						);
					})
				)
				.subscribe((res: any) => {
					this.listBeneficiaire = res.content || [];
					this.listBeneficiaireInput = res.content || [];
				});
				}
				// else{
				// 	this.facade.beneficiaireService.getByServiceAndRegion(this.facade.dataStorageService.getService()?.id,
				// 		this.facade.dataStorageService.getRegion()?.id)?.subscribe({
				// 		next: (beneficiaires) => {
				// 			this.listBeneficiaire = beneficiaires;
				// 			this.isLoadingBeneficiaires.value = false;
				// 		}
				// 	});
				// }
			}

		}

	}

	isIntervenantCheck(spec: Employee): boolean {
		return this.listSelectedIntervenant?.some(
			(specItfc) => specItfc.id === spec.id
		);
	}

	/**
	 * Ajoute ou supprime la spécialité à la liste des spécialités sélectionnées
	 * @param e Element html
	 * @param spe String representant la intervenant choisie
	 */
	updateSelectedIntervenant(e: any, spe: Employee) {
		if (e.target.checked) {
			if (!this.listSelectedIntervenant.some((z) => z.id === spe.id)) {
				this.listSelectedIntervenant.push(spe);
			}
		} else {
			if (this.listSelectedIntervenant.some((z) => z.id === spe.id)) {
				this.listSelectedIntervenant = this.listSelectedIntervenant.filter(
					(z) => z.id !== spe.id
				);
			}
		}
	}

	isModuleDisabled(spec: string): boolean {
		return this.listModuleToCreate?.includes(spec)
			|| (this.listModuleToCreate.length + 1 == this.listSelectedModule.length && !this.listSelectedModule?.includes(spec));
	}

	isModuleCheck(spec: string): boolean {
		return this.listSelectedModule?.some(
			(specItfc) => specItfc === spec
		);
	}

	startDateChanged() {
		let calculatedDateLimite;
		if (this.dateDebut.value != null) {
			calculatedDateLimite = new Date(this.dateDebut.value);
			this.form.controls['dateLimite'].setValue(new Date(calculatedDateLimite.setMonth(calculatedDateLimite.getMonth() + PeriodeExecutionByType[this.typePrestation.value])));
		}
		this.form.controls['periode'].setValue(PeriodeExecutionByType[this.typePrestation?.value]);
		this.form.controls['duree'].setValue(DureeExecutionByType[this.typePrestation?.value]);
		this.form.controls['dureePrevisionnelle'].setValue(DureeExecutionByType[this.typePrestation?.value]);
	}

	onCheckServiceChefFileChanged(evt) {
		this.showChefFileServiceListInput = evt.target.checked;
	}
	/**
	 * Ajoute ou supprime la spécialité à la liste des spécialités sélectionnées
	 * @param e Element html
	 * @param spe String representant la expertise choisie
	 */
	updateSelectedModule(e: any, spe: string) {
		if (e.target.checked) {
			if (!this.listSelectedModule.some((z) => z === spe)) {
				this.listSelectedModule.push(spe);
			}
		} else {
			if (this.listSelectedModule.some((z) => z === spe)) {
				this.listSelectedModule = this.listSelectedModule.filter(
					(z) => z !== spe
				);
			}
		}

		if (this.listSelectedModule.length != this.listModuleToCreate.length) {
			this.showFieldModuleEmployee = true;
		} else {
			this.showFieldModuleEmployee = false;
		}
	}

	isModuleAlreadyCreatedForQD(): void {
		if (this.isAddForm) {
			if (this.listModules?.some(e => e.typePrestation === this.form.get('typePrestation').value)) {
				this.showErrorModuleAlreadyCreated = true
			}
		}
	}

	shouldCreateModuleSP(): void {
		console.log(this.prestation.typePrestation);
		console.log(this.prestation.statutBeneficiaire);
		console.log(this.form.get('statut')?.value);
		console.log(this.form.get('natureAbandon')?.value);
		console.log(this.listSelectedModule);
		if (!this.isIntervenant && (this.prestation.typePrestation == PrestationType.CAMEO || this.prestation.typePrestation == PrestationType.EAP)
			&& (this.prestation.statutBeneficiaire == StatutBeneficiaire.EEPRIV || this.prestation.statutBeneficiaire == StatutBeneficiaire.EEPUB)
			&& this.form.get('statut')?.value == PrestationStatut.CLOT && this.form.get('natureAbandon')?.value == NatureAbandon.NATABANDON8
			&& !this.listSelectedModule.some(e => e === PrestationType.SP)) {
			this.showFieldChoixIntervenantSP = true;
		}
	}

	checkDatePrestationBetweenBdc(): void {
		let selectedBonCommande = this.listBonCommande.find(x => x.id == this.form.get('bonCommande').value)
		if (selectedBonCommande != null && (this.form.get('dateDebut').value < this.dateUtils.convertStringToDate(selectedBonCommande.dateDebut)
			|| this.form.get('dateFin').value > this.dateUtils.convertStringToDate(selectedBonCommande.dateFin))) {
			this.showErrorDatesNotBetweenBdc = true
		}
	}

	submitForm() {
		this.showErrorDatesNotBetweenBdc = false;
		this.showErrorModuleAlreadyCreated = false
		if (this.typePrestation.value != PrestationType.QD) {
			this.isModuleAlreadyCreatedForQD();
		}
		// if(!this.isIntervenant){
		// 	this.checkDatePrestationBetweenBdc()
		// }

		if (this.form.valid && !this.showErrorModuleAlreadyCreated && !this.showErrorDatesNotBetweenBdc) {
			this.isValidateButtonClicked.value = true;
			this.bsModalRef.hide();

			if (this.isAddForm) {
				if(this.isIntervenant){
					this.prestation.beneficiaire = this.listBeneficiaire?.find(x => x.id == this.form.get('beneficiaire').value);
				}
				if (this.form.get('intervenant').value != null) {
					this.prestation.statut = this.PrestationStatutEnum.COURS;
				} else {
					this.prestation.statut = this.PrestationStatutEnum.OUVERT;
				}
			} else {
				if (this.prestation.statut == this.PrestationStatutEnum.OUVERT && this.form.get('intervenant').value != null) {
					this.prestation.statut = this.PrestationStatutEnum.COURS;
					this.form.controls['dateValidation'].setValue(new Date());
				} else {
					this.prestation.statut = this.form.get('statut').value;
				}
			}
			this.prestation.natureAbandon = this.form.get('natureAbandon').value;
			this.prestation.commentaireAbandon = this.form.get('commentaireAbandon').value;
			this.prestation.oldDuree = this.prestation.duree;
			this.prestation.intervenants = this.listSelectedIntervenant;
			this.prestation.typePrestation = this.form.get('typePrestation').value;
			this.prestation.dateDebut = new Date(new Date(this.form.get('dateDebut').value).setHours(12, 0, 0, 0)).toISOString();
			if (this.form.get('dateFin').value != null) {
				this.prestation.dateFin = new Date(new Date(this.form.get('dateFin').value).setHours(12, 0, 0, 0)).toISOString();
			}
			if (this.form.get('dateDepot').value != null) {
				this.prestation.dateDepot = new Date(new Date(this.form.get('dateDepot').value).setHours(12, 0, 0, 0)).toISOString();
			}
			this.prestation.dateValidation = this.form.get('dateValidation').value;
			this.prestation.dateLimite = new Date(new Date(this.form.get('dateLimite').value).setHours(12, 0, 0, 0)).toISOString();
			this.prestation.intervenant = this.listIntervenant?.find(x => x.id == this.form.get('intervenant').value);
			this.prestation.raison = this.form.get('raison').value;
			this.prestation.imperatifs = this.form.get('imperatifs').value;
			//this.prestation.etatQualification = this.form.get('etatQualification').value;
			this.prestation.periode = this.form.get('periode').value;
			this.prestation.duree = this.form.get('duree').value;
			this.prestation.dureePrevisionnelle = this.form.get('dureePrevisionnelle').value;
			this.prestation.situation = this.listSituation?.find(x => x.id == this.form.get('situation').value);
			//this.prestation.origineDemande = this.listOrigineDemande?.find(x => x.id == this.form.get('origineDemande')?.value); 
			this.prestation.prescripteur = this.listPrescripteur?.find(x => x.id == this.form.get('prescripteur')?.value);
			this.prestation.prescripteurContact = this.listPrescripteurContact?.find(x => x.id == this.form.get('prescripteurContact')?.value);
			this.prestation.raisonDemandeAccomp = this.form.get('raisonDemandeAccomp').value;
			this.prestation.objectifPro = this.listObjectifPro?.find(x => x.id == this.form.get('objectifPro').value);
			this.prestation.metiersCibles = this.form.get('metiersCibles').value;
			this.prestation.typeAccompagnement = this.form.get('typeAccompagnement').value;
			this.prestation.difficultes = this.form.get('difficultes').value;
			this.prestation.besoins = this.form.get('besoins').value;
			this.prestation.origineHandicap = this.form.get('origineHandicap').value;
			this.prestation.rapportHandicap = this.form.get('rapportHandicap').value;
			this.prestation.logement = this.form.get('logement').value;
			this.prestation.sante = this.form.get('sante').value;
			this.prestation.situationFinanciere = this.form.get('situationFinanciere').value;
			this.prestation.situationFamiliale = this.form.get('situationFamiliale').value;
			this.prestation.smBilan = this.form.get('smBilan').value;
			this.prestation.smAccomp = this.form.get('smAccomp').value;
			this.prestation.deMetiersCibles = this.form.get('deMetiersCibles').value;
			this.prestation.deProjetPro = this.form.get('deProjetPro').value;
			this.prestation.deRuptureParcours = this.form.get('deRuptureParcours').value;
			this.prestation.deBesoinsIdent = this.form.get('deBesoinsIdent').value;
			this.prestation.eeLimites = this.form.get('eeLimites').value;
			this.prestation.eeQuestEmploi = this.form.get('eeQuestEmploi').value;
			this.prestation.eeBesoinsAdapt = this.form.get('eeBesoinsAdapt').value;
			this.prestation.eePbAccess = this.form.get('eePbAccess').value;
			this.prestation.eeAccompDejaMene = this.form.get('eeAccompDejaMene').value;
			this.prestation.eeNomEntreprise = this.form.get('eeNomEntreprise').value;
			this.prestation.eeNomContactEntreprise = this.form.get('eeNomContactEntreprise').value;
			this.prestation.eePrenomContactEntreprise = this.form.get('eePrenomContactEntreprise').value;
			this.prestation.eeMailContactEntreprise = this.form.get('eeMailContactEntreprise').value;
			this.prestation.eeTelContactEntreprise = this.form.get('eeTelContactEntreprise').value;
			this.prestation.eeSyntheseSitEmployeur = this.form.get('eeSyntheseSitEmployeur').value;
			this.prestation.eeHoraires = this.form.get('eeHoraires').value;
			this.prestation.eeFichePoste = this.form.get('eeFichePoste').value;
			this.prestation.efLimiteCapacite = this.form.get('efLimiteCapacite').value;
			this.prestation.efQuestionnement = this.form.get('efQuestionnement').value;
			this.prestation.efAccompDejaMene = this.form.get('efAccompDejaMene').value;
			this.prestation.efAccessibilite = this.form.get('efAccessibilite').value;
			this.prestation.efTypeFormation = this.form.get('efTypeFormation').value;
			this.prestation.efBesoinsAt = this.form.get('efBesoinsAt').value;
			this.prestation.efNomCentreFormation = this.form.get('efNomCentreFormation').value;
			this.prestation.efPlanning = this.form.get('efPlanning').value;
			this.prestation.efRemarqueRef = this.form.get('efRemarqueRef').value;
			this.prestation.syntheseInfo = this.form.get('syntheseInfo').value;
			this.prestation.premieresOrientations = this.form.get('premieresOrientations').value;
			this.prestation.langage = this.form.get('langage').value;
			this.prestation.praxie = this.form.get('praxie').value;
			this.prestation.memoire = this.form.get('memoire').value;
			this.prestation.fonctExecutif = this.form.get('fonctExecutif').value;
			this.prestation.fonctAttent = this.form.get('fonctAttent').value;
			this.prestation.cognitionSociale = this.form.get('cognitionSociale').value;
			this.prestation.comportement = this.form.get('comportement').value;
			this.prestation.preconisations = this.form.get('preconisations').value;
			this.prestation.observations = this.form.get('observations').value;
			this.prestation.analyseAdequation = this.form.get('analyseAdequation').value;
			this.prestation.recommandantions = this.form.get('recommandantions').value;
			if (this.typePrestation.value == PrestationType.QD) {
				this.prestation.statutBeneficiaire = this.form.get('statutBeneficiaire').value;
			}
			// this.prestation.datePrescription = this.form.get('datePrescription').value;
			// this.prestation.datePremierContact = this.form.get('datePremierContact').value;
			// this.prestation.datePremierRv = this.form.get('datePremierRv').value;
			// this.prestation.dateS3 = this.form.get('dateS3').value;
			// this.prestation.dateS6 = this.form.get('dateS6').value;
			// this.prestation.preconisationsProposes = this.form.get('preconisationsProposes').value;
			// this.prestation.comprehensionPreco = this.form.get('comprehensionPreco').value;
			// this.prestation.description = this.form.get('description').value;
			// this.prestation.complements = this.form.get('complements').value;
			// this.prestation.nomS3 = this.form.get('nomS3').value;
			// this.prestation.prenomS3 = this.form.get('prenomS3').value;
			// this.prestation.fonctionS3 = this.form.get('fonctionS3').value;
			// this.prestation.preconisationMeoS3 = this.form.get('preconisationMeoS3').value;
			// this.prestation.descriptionS3 = this.form.get('descriptionS3').value;
			// this.prestation.freinS3 = this.form.get('freinS3').value;
			// this.prestation.reponseS3 = this.form.get('reponseS3').value;
			// this.prestation.nomS6 = this.form.get('nomS6').value;
			// this.prestation.prenomS6 = this.form.get('prenomS6').value;
			// this.prestation.fonctionS6 = this.form.get('fonctionS6').value;
			// this.prestation.preconisationMeoS6 = this.form.get('preconisationMeoS6').value;
			// this.prestation.descriptionS6 = this.form.get('descriptionS6').value;
			// this.prestation.freinS6 = this.form.get('freinS6').value;
			// this.prestation.reponseS6 = this.form.get('reponseS6').value;
			this.prestation.dateContactPrescripteur = this.form.get('dateContactPrescripteur').value;
			this.prestation.dateContactPersonne = this.form.get('dateContactPersonne').value;
			this.prestation.dateContactEmployeur = this.form.get('dateContactEmployeur').value;
			this.prestation.meoSolutions = this.form.get('meoSolutions').value;
			this.prestation.precoNonMeo = this.form.get('precoNonMeo').value;
			this.prestation.raisons = this.form.get('raisons').value;
			this.prestation.propositionAs = this.form.get('propositionAs').value;
			this.prestation.propositionAutre = this.form.get('propositionAutre').value;
			this.prestation.propositionAutreDetails = this.form.get('propositionAutreDetails').value;
			this.prestation.heuresDeclarees = this.form.get('heuresDeclarees').value;

			this.prestation.ressourcesFinancieres = this.form.get('ressourcesFinancieres').value;
			this.prestation.niveauRendement = this.form.get('niveauRendement').value;
			this.prestation.satisfaction = this.form.get('satisfaction').value;
			this.prestation.stress = this.form.get('stress').value;
			this.prestation.forces = this.form.get('forces').value;
			this.prestation.attention = this.form.get('attention').value;
			this.prestation.gnosies = this.form.get('gnosies').value;
			this.prestation.pointVigilence = this.form.get('pointVigilence').value;
			this.prestation.ppIntitulePoste = this.form.get('ppIntitulePoste').value;
			this.prestation.ppDescriptionPosteBenef = this.form.get('ppDescriptionPosteBenef').value;
			this.prestation.ppDescriptionPosteOf = this.form.get('ppDescriptionPosteOf').value;
			this.prestation.ppEntrepriseVise = this.form.get('ppEntrepriseVise').value;
			this.prestation.idQualification = this.form.get('idQualification').value;
			if (this.showChefFileServiceListInput) {
				this.prestation.serviceChefFile = this.listServiceChefFile?.find(x => x.id == this.form.get('serviceChefFile').value);
			} else {
				this.prestation.serviceChefFile = null;
			}
			this.prestation.numeroCommande = this.form.get('numeroCommande').value;
			if (!this.isIntervenant) {
				this.prestation.service = this.facade.dataStorageService.getService();
				//this.prestation.bonCommande = this.listBonCommande?.find(x => x.id == this.form.get('bonCommande').value); 
			}

			if (this.prestation.id) {
				if (this.typePrestation.value == PrestationType.QD) {
					this.prestation.modules = this.listSelectedModule.filter(item => this.listModuleToCreate.indexOf(item) < 0);
				} else {
					this.prestation.modules = this.listSelectedModule;
				}
			} else {
				this.prestation.modules = this.listSelectedModule;
			}
			this.prestation.intervenantModule = this.listIntervenant?.find(x => x.id == this.form.get('intervenantModule')?.value);
			this.prestation.dateDebutContrat = this.form.get('dateDebutContrat')?.value;
			this.prestation.dateFinContrat = this.form.get('dateFinContrat')?.value;
			this.prestation.salarieEntreprise = this.form.get('salarieEntreprise').value;
			this.prestation.accordEmployeur = this.form.get('accordEmployeur').value;
			this.prestation.arretTravail = this.form.get('arretTravail').value;
			this.prestation.agentFonctPub = this.form.get('agentFonctPub').value;
			this.prestation.accordHandicap = this.form.get('accordHandicap').value;

			// let beneficiaire = this.listBeneficiaire?.find(x => x.id == this.form.get('beneficiaire').value);
			// beneficiaire.origineHandicap = this.form.get('origineHandicap')?.value;
			// beneficiaire.rapportHandicap = this.form.get('rapportHandicap')?.value;
			// beneficiaire.tauxReconnaissance = this.listTauxReconnaissance?.find(x => x.id == this.form.get('tauxReconnaissance')?.value); 
			// beneficiaire.niveauEtude = this.listNiveauEtude?.find(x => x.id == this.form.get('niveauEtude')?.value); 
			// beneficiaire.statutProfessionnel = this.listStatutProfessionnel?.find(x => x.id == this.form.get('statutProfessionnel')?.value); 
			// beneficiaire.eligibiliteBeneficiaire = this.listEligibiliteBeneficiaire?.find(x => x.id == this.form.get('eligibiliteBeneficiaire')?.value); 
			// beneficiaire.doleances = this.form.get('doleances')?.value;
			// beneficiaire.environnementSocial = this.form.get('environnementSocial')?.value;
			// beneficiaire.diplomes = [];
			console.log(this.prestation);
			this.sendForm.emit();
			// this.facade.beneficiaireService.updateBeneficiaire(beneficiaire).subscribe({
			// 	complete: () =>{ 
			// 		console.log("finish update benef");
			// 		this.sendForm.emit();
			// 	}
			// })

		} else {
			// this.facade.toastService.createErrorToast();
			this.isValidateButtonClicked.value = false;
		}
	}

	onStatutBeneficiciareChanged() {
		switch (this.statutBeneficiaire.value) {
			// case StatutBeneficiaire.DE: {
			// 	this.isStatutDESelected = true;
			// 	this.isStatutEESelected = false;
			// 	this.isStatutEFSelected = false;
			// 	break;
			// }
			case StatutBeneficiaire.EEPUB: {
				this.isStatutDESelected = false;
				this.isStatutEESelected = true;
				this.isStatutEFSelected = false;
				break;
			}
			case StatutBeneficiaire.EEPRIV: {
				this.isStatutDESelected = false;
				this.isStatutEESelected = true;
				this.isStatutEFSelected = false;
				break;
			}
			case StatutBeneficiaire.EF: {
				this.isStatutDESelected = false;
				this.isStatutEESelected = false;
				this.isStatutEFSelected = true;
				break;
			}
		}
	}

	onBeneficiciareChanged() {
		const beneficiaire = this.listBeneficiaire.find(x => x.id == this.form.get('beneficiaire').value);
		this.form.controls['tauxReconnaissance'].setValue(beneficiaire.tauxReconnaissance?.id);
		this.form.controls['niveauEtude'].setValue(beneficiaire.niveauEtude?.id);
		//this.form.controls['niveauQualification'].setValue(beneficiaire.niveauQualification?.id);
		this.form.controls['statutProfessionnel'].setValue(beneficiaire.statutProfessionnel?.id);
		this.form.controls['origineHandicap'].setValue(beneficiaire.origineHandicap);
		this.form.controls['rapportHandicap'].setValue(beneficiaire.rapportHandicap);
		this.form.controls['doleances'].setValue(beneficiaire.doleances);
		this.form.controls['environnementSocial'].setValue(beneficiaire.environnementSocial);

		this.showChefFileBoolInput = false;
		if (this.typePrestation.value == PrestationType.QD && beneficiaire.typeHandicaps?.length > 1) {
			this.showChefFileBoolInput = true;
			this.listServiceChefFile = [];
			this.facade.serviceService.getAllService().subscribe({
				next: (val) => {
					console.log(beneficiaire.typeHandicaps);
					val.forEach(e => {
						if (beneficiaire.typeHandicaps.some(f => f.id === e.typeHandicap.id) && e.id != this.facade.dataStorageService.getService().id) {
							this.listServiceChefFile.push(e);
						}
					})
				}
			})
		}
	}

	onPrescripteurChanged() {
		const prescripteur = this.listPrescripteur.find(x => x.id == this.form.get('prescripteur').value);
		this.listPrescripteurContact = prescripteur?.contacts;
	}

	onStatutProChanged() {
		const statut = this.listStatutProfessionnel?.find(x => x.id == this.form.get('statutProfessionnel')?.value);
		this.showFieldDateDebutContrat = false;
		this.showFieldDateFinContrat = false;
		if (statut?.name?.includes("CDD")) {
			this.showFieldDateDebutContrat = true;
			this.showFieldDateFinContrat = true;
		}

		if (statut?.name?.includes("CDI")) {
			this.showFieldDateDebutContrat = true;
		}
	}

	onStatutChanged() {
		const statut = this.form.get('statut')?.value;
		this.showFieldNatureAbandon = false;
		this.isSelectedStatutANNULE = false;
		this.isSelectedStatutCLOT = false
		if (statut == PrestationStatut.ANNULE || statut == PrestationStatut.CLOT) {
			this.showFieldNatureAbandon = true;
			if (statut == PrestationStatut.ANNULE) {
				this.isSelectedStatutANNULE = true;
			}
			if (statut == PrestationStatut.CLOT) {
				this.isSelectedStatutCLOT = true;
			}
		}
		this.shouldCreateModuleSP();
	}

	// onNatureAbandonChanged() { 
	// 	const natureAbandon = this.form.get('natureAbandon')?.value;
	// 	this.showFieldCommentaireAbandon = false;
	// 	if(natureAbandon == NatureAbandon.NATABANDON1 || natureAbandon == NatureAbandon.NATABANDON3 || natureAbandon == NatureAbandon.NATABANDON5){
	// 		this.showFieldCommentaireAbandon = true;
	// 	}
	// }

	onQualificationSelected() {
		const qualification = this.listQualification.find(x => x.id == this.form.get('idQualification').value);
		this.form.controls['beneficiaire'].setValue(qualification.beneficiaire?.id);
		this.form.controls['prescripteur'].setValue(qualification.prescripteur?.id);
		this.form.controls['prescripteurContact'].setValue(qualification.prescripteurContact?.id);
		this.form.controls['intervenant'].setValue(qualification.intervenant?.id);
		this.form.controls['numeroCommande'].setValue(qualification.numeroCommande);
		//this.form.controls['bonCommande'].setValue(qualification.bonCommande?.id);
		this.form.controls['statutBeneficiaire'].setValue(qualification.statutBeneficiaire);
		
		this.onPrescripteurChanged();
		if(!this.isIntervenant){
			this.selectBeneficiaire(qualification.beneficiaire);
			this.prestation.beneficiaire = qualification.beneficiaire;
		}
		//const beneficiaire = this.listBeneficiaire.find(x => x.id == this.form.get('beneficiaire').value);
		//this.prestation.beneficiaire = qualification.beneficiaire;
		//this.form.controls['beneficiaire'].disable();

		this.facade.prestationService.getPrestationByIdQualification(this.form.get('idQualification').value).subscribe({
			next: (val) => {
				this.listModules = val;
			},
			error: (err) => {
				this.logger.error(err);
			}
		});
	}

	toggleEtatQualificationSelected() {

	}

	togglePrestationTypeSelected() {
		//this.startDateChanged();
		switch (this.typePrestation.value) {
			case PrestationType.QD: {
				this.isQDSelected = true;
				this.isASSelected = false;
				this.isACSelected = false;
				this.isCAMEOSelected = false;
				this.isEAPSelected = false;
				this.isSPSelected = false;
				// this.form.controls['bonCommande'].enable();

				if (this.prestation.id) {
					this.facade.prestationService.getPrestationByIdQualification(this.prestation.id).subscribe({
						next: (val) => {
							this.listModules = val;
							this.listModules.forEach((currentValue) => {
								if (currentValue.typePrestation) {
									this.listSelectedModule.push(currentValue.typePrestation);
									this.listModuleToCreate.push(currentValue.typePrestation);
								}
							});
						},
						error: (err) => {
							this.logger.error(err);
						}
					});
				}
				break;
			}
			case PrestationType.AC: {
				this.isQDSelected = false;
				this.isASSelected = false;
				this.isACSelected = true;
				this.isCAMEOSelected = false;
				this.isEAPSelected = false;
				this.isSPSelected = false;
				//this.form.controls['bonCommande'].disable();
				if (this.prestation.idQualification) {
					this.facade.prestationService.getPrestationByIdQualification(this.prestation.idQualification).subscribe({
						next: (val) => {
							this.listModules = val;
							this.listModules.forEach((currentValue) => {
								if (currentValue.typePrestation) {
									this.listSelectedModule.push(currentValue.typePrestation);
									this.listModuleToCreate.push(currentValue.typePrestation);
								}
							});
						},
						error: (err) => {
							this.logger.error(err);
						}
					});
				}
				break;
			}
			case PrestationType.AS: {
				this.isQDSelected = false;
				this.isASSelected = true;
				this.isACSelected = false;
				this.isCAMEOSelected = false;
				this.isEAPSelected = false;
				this.isSPSelected = false;
				//this.form.controls['bonCommande'].disable();
				if (this.prestation.idQualification) {
					this.facade.prestationService.getPrestationByIdQualification(this.prestation.idQualification).subscribe({
						next: (val) => {
							this.listModules = val;
							this.listModules.forEach((currentValue) => {
								if (currentValue.typePrestation) {
									this.listSelectedModule.push(currentValue.typePrestation);
									this.listModuleToCreate.push(currentValue.typePrestation);
								}
							});
						},
						error: (err) => {
							this.logger.error(err);
						}
					});
				}
				break;
			}
			case PrestationType.CAMEO: {
				this.isQDSelected = false;
				this.isASSelected = false;
				this.isACSelected = false;
				this.isCAMEOSelected = true;
				this.isEAPSelected = false;
				this.isSPSelected = false;
				//this.form.controls['bonCommande'].disable(); 
				if (this.prestation.idQualification) {
					this.facade.prestationService.getPrestationByIdQualification(this.prestation.idQualification).subscribe({
						next: (val) => {
							this.listModules = val;
							this.listModules.forEach((currentValue) => {
								if (currentValue.typePrestation) {
									this.listSelectedModule.push(currentValue.typePrestation);
									this.listModuleToCreate.push(currentValue.typePrestation);
								}
							});
						},
						error: (err) => {
							this.logger.error(err);
						}
					});
				}
				break;
			}
			case PrestationType.EAP: {
				this.isQDSelected = false;
				this.isASSelected = false;
				this.isACSelected = false;
				this.isCAMEOSelected = false;
				this.isEAPSelected = true;
				this.isSPSelected = false;
				if (this.prestation.idQualification) {
					this.facade.prestationService.getPrestationByIdQualification(this.prestation.idQualification).subscribe({
						next: (val) => {
							this.listModules = val;
							this.listModules.forEach((currentValue) => {
								if (currentValue.typePrestation) {
									this.listSelectedModule.push(currentValue.typePrestation);
									this.listModuleToCreate.push(currentValue.typePrestation);
								}
							});
						},
						error: (err) => {
							this.logger.error(err);
						}
					});
				}
				//this.form.controls['bonCommande'].disable();
				break;
			}
			case PrestationType.SP: {
				this.isQDSelected = false;
				this.isASSelected = false;
				this.isACSelected = false;
				this.isCAMEOSelected = false;
				this.isEAPSelected = false;
				this.isSPSelected = true;
				//this.form.controls['bonCommande'].disable();
				if (this.prestation.idQualification) {
					this.facade.prestationService.getPrestationByIdQualification(this.prestation.idQualification).subscribe({
						next: (val) => {
							this.listModules = val;
							this.listModules.forEach((currentValue) => {
								if (currentValue.typePrestation) {
									this.listSelectedModule.push(currentValue.typePrestation);
									this.listModuleToCreate.push(currentValue.typePrestation);
								}
							});
						},
						error: (err) => {
							this.logger.error(err);
						}
					});
				}
				break;
			}
			default: {
				break;
			}
		}
	}

	get typePrestation() {
		return this.form.get('typePrestation');
	}
	get dateDebut() {
		return this.form.get('dateDebut');
	}
	get dateFin() {
		return this.form.get('dateFin');
	}
	get dateDepot() {
		return this.form.get('dateDepot');
	}
	get dateValidation() {
		return this.form.get('dateValidation');
	}
	get dateLimite() {
		return this.form.get('dateLimite');
	}
	get statut() {
		return this.form.get('statut');
	}
	get natureAbandon() {
		return this.form.get('natureAbandon');
	}
	get commentaireAbandon() {
		return this.form.get('commentaireAbandon');
	}
	get etatQualification() {
		return this.form.get('etatQualification');
	}
	get intervenants() {
		return this.form.get('intervenants');
	}
	get intervenant() {
		return this.form.get('intervenant');
	}
	get intervenantModule() {
		return this.form.get('intervenantModule');
	}
	get beneficiaire() {
		return this.form.get('beneficiaire');
	}
	get raison() {
		return this.form.get('raison');
	}
	get imperatifs() {
		return this.form.get('imperatifs');
	}
	get situation() {
		return this.form.get('situation');
	}
	// get origineDemande() {
	// 	return this.form.get('origineDemande');
	// }
	get prescripteur() {
		return this.form.get('prescripteur');
	}
	get prescripteurContact() {
		return this.form.get('prescripteurContact');
	}
	get raisonDemandeAccomp() {
		return this.form.get('raisonDemandeAccomp');
	}
	get objectifPro() {
		return this.form.get('objectifPro');
	}
	get competenceProPerso() {
		return this.form.get('competenceProPerso');
	}
	get besoinsFormation() {
		return this.form.get('besoinsFormation');
	}
	get metiersCibles() {
		return this.form.get('metiersCibles');
	}
	get secteursRecherches() {
		return this.form.get('secteursRecherches');
	}
	get preferencesGeo() {
		return this.form.get('preferencesGeo');
	}
	get contraintesHandicap() {
		return this.form.get('contraintesHandicap');
	}
	get syntheseInfo() {
		return this.form.get('syntheseInfo');
	}
	get premieresOrientations() {
		return this.form.get('premieresOrientations');
	}
	get langage() {
		return this.form.get('langage');
	}
	get praxie() {
		return this.form.get('praxie');
	}
	get memoire() {
		return this.form.get('memoire');
	}
	get fonctExecutif() {
		return this.form.get('fonctExecutif');
	}
	get fonctAttent() {
		return this.form.get('fonctAttent');
	}
	get cognitionSociale() {
		return this.form.get('cognitionSociale');
	}
	get comportement() {
		return this.form.get('comportement');
	}
	get preconisations() {
		return this.form.get('preconisations');
	}
	get observations() {
		return this.form.get('observations');
	}
	get doleances() {
		return this.form?.get('doleances');
	}
	get environnementSocial() {
		return this.form?.get('environnementSocial');
	}
	get eligibiliteBeneficiaire() {
		return this.form?.get('eligibiliteBeneficiaire');
	}
	get statutProfessionnel() {
		return this.form?.get('statutProfessionnel');
	}
	// get orientationMdph() {
	// 	return this.form.get('orientationMdph');
	// }
	// get freins() {
	// 	return this.form.get('freins');
	// }
	// get ressources() {
	// 	return this.form.get('ressources');
	// }
	// get contraintes() {
	// 	return this.form.get('contraintes');
	// }
	// get propositionsActions() {
	// 	return this.form.get('propositionsActions');
	// }
	// get planActionPerso() {
	// 	return this.form.get('planActionPerso');
	// }
	get analyseAdequation() {
		return this.form.get('analyseAdequation');
	}
	get recommandantions() {
		return this.form.get('recommandantions');
	}
	get duree() {
		return this.form.get('duree');
	}
	get dureePrevisionnelle() {
		return this.form.get('dureePrevisionnelle');
	}
	get periode() {
		return this.form.get('periode');
	}
	get typeAccompagnement() {
		return this.form.get('typeAccompagnement');
	}
	get difficultes() {
		return this.form.get('difficultes');
	}
	get besoins() {
		return this.form.get('besoins');
	}
	get origineHandicap() {
		return this.form.get('origineHandicap');
	}
	get rapportHandicap() {
		return this.form.get('rapportHandicap');
	}
	get logement() {
		return this.form.get('logement');
	}
	get sante() {
		return this.form.get('sante');
	}
	get situationFinanciere() {
		return this.form.get('situationFinanciere');
	}
	get situationFamiliale() {
		return this.form.get('situationFamiliale');
	}
	get smBilan() {
		return this.form.get('smBilan');
	}
	get smAccomp() {
		return this.form.get('smAccomp');
	}
	get deMetiersCibles() {
		return this.form.get('deMetiersCibles');
	}
	get deProjetPro() {
		return this.form.get('deProjetPro');
	}
	get deRuptureParcours() {
		return this.form.get('deRuptureParcours');
	}
	get deBesoinsIdent() {
		return this.form.get('deBesoinsIdent');
	}
	get eeLimites() {
		return this.form.get('eeLimites');
	}
	get eeQuestEmploi() {
		return this.form.get('eeQuestEmploi');
	}
	get eeBesoinsAdapt() {
		return this.form.get('eeBesoinsAdapt');
	}
	get eePbAccess() {
		return this.form.get('eePbAccess');
	}
	get eeAccompDejaMene() {
		return this.form.get('eeAccompDejaMene');
	}
	get eeNomEntreprise() {
		return this.form.get('eeNomEntreprise');
	}
	get eeNomContactEntreprise() {
		return this.form.get('eeNomContactEntreprise');
	}
	get eePrenomContactEntreprise() {
		return this.form.get('eePrenomContactEntreprise');
	}
	get eeMailContactEntreprise() {
		return this.form.get('eeMailContactEntreprise');
	}
	get eeTelContactEntreprise() {
		return this.form.get('eeTelContactEntreprise');
	}
	get eeSyntheseSitEmployeur() {
		return this.form.get('eeSyntheseSitEmployeur');
	}
	get eeHoraires() {
		return this.form.get('eeHoraires');
	}
	get eeFichePoste() {
		return this.form.get('eeFichePoste');
	}
	get efLimiteCapacite() {
		return this.form.get('efLimiteCapacite');
	}
	get efQuestionnement() {
		return this.form.get('efQuestionnement');
	}
	get efAccompDejaMene() {
		return this.form.get('efAccompDejaMene');
	}
	get efAccessibilite() {
		return this.form.get('efAccessibilite');
	}
	get efTypeFormation() {
		return this.form.get('efTypeFormation');
	}
	get efBesoinsAt() {
		return this.form.get('efBesoinsAt');
	}
	get efNomCentreFormation() {
		return this.form.get('efNomCentreFormation');
	}
	get efPlanning() {
		return this.form.get('efPlanning');
	}
	get efRemarqueRef() {
		return this.form.get('efRemarqueRef');
	}
	get statutBeneficiaire() {
		return this.form.get('statutBeneficiaire');
	}
	get bonCommande() {
		return this.form.get('bonCommande');
	}
	get numeroCommande() {
		return this.form.get('numeroCommande');
	}
	// get datePrescription(){
	// 	return this.form.get('datePrescription');
	// }
	// get datePremierContact(){
	// 	return this.form.get('datePremierContact');
	// }
	// get datePremierRv(){
	// 	return this.form.get('datePremierRv');
	// }
	// get dateS3(){
	// 	return this.form.get('dateS3');
	// }
	// get dateS6(){
	// 	return this.form.get('dateS6');
	// }
	// get preconisationsProposes(){
	// 	return this.form.get('preconisationsProposes');
	// }
	// get comprehensionPreco(){
	// 	return this.form.get('comprehensionPreco');
	// }
	// get description(){
	// 	return this.form.get('description');
	// }
	// get complements(){
	// 	return this.form.get('complements');
	// }
	// get nomS3(){
	// 	return this.form.get('nomS3');
	// }
	// get prenomS3(){
	// 	return this.form.get('prenomS3');
	// }
	// get fonctionS3(){
	// 	return this.form.get('fonctionS3');
	// }
	// get preconisationMeoS3(){
	// 	return this.form.get('preconisationMeoS3');
	// }
	// get descriptionS3(){
	// 	return this.form.get('descriptionS3');
	// }
	// get freinS3(){
	// 	return this.form.get('freinS3');
	// }
	// get reponseS3(){
	// 	return this.form.get('reponseS3');
	// }
	// get nomS6(){
	// 	return this.form.get('nomS6');
	// }
	// get prenomS6(){
	// 	return this.form.get('prenomS6');
	// }
	// get fonctionS6(){
	// 	return this.form.get('fonctionS6');
	// }
	// get preconisationMeoS6(){
	// 	return this.form.get('preconisationMeoS6');
	// }
	// get descriptionS6(){
	// 	return this.form.get('descriptionS6');
	// }
	// get freinS6(){
	// 	return this.form.get('freinS6');
	// }
	// get reponseS6(){
	// 	return this.form.get('reponseS6');
	// }
	get dateContactPrescripteur() {
		return this.form.get('dateContactPrescripteur');
	}
	get dateContactPersonne() {
		return this.form.get('dateContactPersonne');
	}
	get dateContactEmployeur() {
		return this.form.get('dateContactEmployeur');
	}
	get meoSolutions() {
		return this.form.get('meoSolutions');
	}
	get precoNonMeo() {
		return this.form.get('precoNonMeo');
	}
	get raisons() {
		return this.form.get('raisons');
	}
	get propositionAs() {
		return this.form.get('propositionAs');
	}
	get propositionAutre() {
		return this.form.get('propositionAutre');
	}
	get propositionAutreDetails() {
		return this.form.get('propositionAutreDetails');
	}
	get heuresDeclarees() {
		return this.form.get('heuresDeclarees');
	}
	get ressourcesFinancieres() {
		return this.form.get('ressourcesFinancieres');
	}
	get niveauRendement() {
		return this.form.get('niveauRendement');
	}
	get satisfaction() {
		return this.form.get('satisfaction');
	}
	get stress() {
		return this.form.get('stress');
	}
	get forces() {
		return this.form.get('forces');
	}
	get attention() {
		return this.form.get('attention');
	}
	get gnosies() {
		return this.form.get('gnosies');
	}
	get pointVigilence() {
		return this.form.get('pointVigilence');
	}
	get ppIntitulePoste() {
		return this.form.get('ppIntitulePoste');
	}
	get ppDescriptionPosteBenef() {
		return this.form.get('ppDescriptionPosteBenef');
	}
	get ppDescriptionPosteOf() {
		return this.form.get('ppDescriptionPosteOf');
	}
	get ppEntrepriseVise() {
		return this.form.get('ppEntrepriseVise');
	}
	get idQualification() {
		return this.form.get('idQualification');
	}
	get serviceChefFile() {
		return this.form.get('serviceChefFile');
	}
	get showServiceChefFile() {
		return this.form.get('showServiceChefFile');
	}
	get dateDebutContrat() {
		return this.form.get('dateDebutContrat');
	}
	get dateFinContrat() {
		return this.form.get('dateFinContrat');
	}
	get salarieEntreprise() {
		return this.form.get('salarieEntreprise');
	}
	get accordEmployeur() {
		return this.form.get('accordEmployeur');
	}
	get arretTravail() {
		return this.form.get('arretTravail');
	}
	get agentFonctPub() {
		return this.form.get('agentFonctPub');
	}
	get accordHandicap() {
		return this.form.get('accordHandicap');
	}

	disableChooseEmployeeButton(): boolean {
		if (this.form.get('dateDebut').value != null
			&& this.form.get('dateLimite').value != null
			&& this.form.get('typePrestation').value != ""
			&& this.form.get('beneficiaire').value != "") {
			if (this.form.get('typePrestation').value == PrestationType.QD
				&& (this.form.get('raison').value == null
					//|| this.form.get('prescripteur').value == ""
					|| this.form.get('situation').value == ""
				)) {
				return true;
			}
			return false;
		}
		return true;
	}

	openModalChooseEmployee() {
		this.selectedTypePrestation = this.form.get('typePrestation').value;
		this.showModal = true;
	}

	selectBeneficiaire(beneficiaire: any) {
		this.form.get('beneficiaire')?.setValue(beneficiaire.id);
		this.beneficiaireInput.setValue(`${beneficiaire.lastName} ${beneficiaire.firstName}`, { emitEvent: false });
		this.prestation.beneficiaire = this.listBeneficiaire?.find(x => x.id == this.form.get('beneficiaire').value);
		this.listBeneficiaireInput = [];
	}

}
